import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined'
import { Avatar, Button, Stack, Typography } from '@mui/material'
import {
  Notification,
  NotificationStatus
} from '@shared/types/notifications.types'
import { TFunction } from 'i18next'
import { getNotificationContent } from '../utils/notification.utils'

interface Props {
  notification: Notification
  t: TFunction
  onLinkClick?: () => void
}

export default function NotificationContent({
  notification,
  t,
  onLinkClick
}: Props) {
  const { title, companyName, showLink, linkText, body } =
    getNotificationContent(notification, t)
  const isRead = notification.status === NotificationStatus.READ

  return (
    <Stack direction='row' spacing='1rem'>
      <Avatar sx={{ bgcolor: 'transparent' }}>
        <MailOutlineOutlinedIcon sx={{ color: 'info.main' }} />
      </Avatar>
      <Stack direction='column'>
        <Typography variant='body1' fontWeight={isRead ? 'normal' : 'bold'}>
          {title}
        </Typography>
        <Typography
          variant='body2'
          color='text.secondary'
          fontWeight={isRead ? 'normal' : 'bold'}
        >
          {companyName}
        </Typography>
        {/* {showLink && (
          <Button
            component={Link}
            to={link || ''}
            variant='text'
            sx={{
              width: 'fit-content',
              padding: '.25rem .3125rem',
              marginTop: '1.5rem'
            }}
          >
            {linkText}
          </Button>
        )} */}
        {showLink && (
          <Button
            variant='text'
            onClick={onLinkClick}
            sx={{
              width: 'fit-content',
              padding: '.25rem .3125rem',
              marginTop: '1.5rem',
              textTransform: 'none'
            }}
          >
            {linkText}
          </Button>
        )}
        {body && (
          <Typography
            variant='body1'
            color='text.secondary'
            sx={{ marginTop: '1.5rem' }}
          >
            {body}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
